import { Link } from "react-router-dom";
import { errorToast, loadingToast } from "../../notification/notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";

const CheckoutIndividual = ({ carts, deliveryOption, selectedAddress }) => {
  let sum = 0;

  carts.forEach((element) => {
    sum += Number(element.product.product_prices[0].price);
  });

  const handleCheckout = () => {
    if(!deliveryOption || !selectedAddress) return errorToast("please select an address and delivery option");
    loadingToast("loading...")
  };
  return (
    <div className="mt-5">
      {carts.map(
        ({
          product: {
            product_image: { front_view },
            product_name,
            product_prices,
            seller: { full_name },
          },
          id,
        }) => (
          <div className="mt-6" key={id}>
            <div className="flex gap-3">
              <div>
                <img src={front_view} alt="item" className="w-20 h-20" />
              </div>
              <div>
                <p className="">{product_name}</p>
                <p className="text-logoRed text-sm cursor-pointer">
                  {full_name} store
                </p>
                <p><FontAwesomeIcon icon={faNairaSign} className="text-sm"/> {`${product_prices[0].price.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  ","
                )}.00`}</p>
              </div>
            </div>
          </div>
        )
      )}
      <p className="text-lg font-semibold mt-8">Order Summary</p>
      <div className="flex justify-between items-center mt-5">
        <div>
          <p className="font-bold text-sm text-label mt-1">Sub Total</p>
          <p className="font-bold text-sm text-label mt-1">Delivery Fee</p>
          <p className="font-bold text-sm mt-1">Total</p>
        </div>
        <div>
          <p className="font-bold text-sm text-label mt-1"><FontAwesomeIcon icon={faNairaSign} className="text-sm"/> {`${sum
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00`}</p>
          <p className="font-bold text-sm text-label mt-1"><FontAwesomeIcon icon={faNairaSign} className="text-sm"/> 0.00</p>
          <p className="font-bold text-sm mt-1"><FontAwesomeIcon icon={faNairaSign} className="text-sm"/> {`${sum
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00`}</p>
        </div>
      </div>

      <div className="mt-7">
        <Link to="/cart">
          <button className="w-full h-10 mt-3 border border-black font-bold rounded-3xl">
            Modify Cart
          </button>
        </Link>
        <button
          className="w-full h-10 mt-3 bg-logoRed text-white font-bold rounded-3xl"
          onClick={handleCheckout}
        >
          Checkout
        </button>
      </div>
    </div>
  );
};

export default CheckoutIndividual;
